<template>
  <div class="max-w-full lg:max-w-3xl mx-auto px-12 lg:px-0">
    <div class="text-2xl font-light text-gray-800">
	    As far as you are aware, is your credit history clear?
	  </div>

	  <div class="mt-4 flex items-center">
	  	<input type="radio" name="input-credit-history" v-model="creditHistory" value="1" id="input-credit-history-perfect" />
	  	<label for="input-credit-history-perfect" class="ml-2 text-base">It's perfect.</label>
	  </div>

	  <div class="mt-2 flex items-center">
	  	<input type="radio" name="input-credit-history" v-model="creditHistory" value="2" id="input-credit-history-late" />
	  	<label for="input-credit-history-late" class="ml-2 text-base">All debts paid but with late payments.</label>
	  </div>

	  <div class="mt-2 flex items-center">
	  	<input type="radio" name="input-credit-history" v-model="creditHistory" value="3" id="input-credit-history-default" />
	  	<label for="input-credit-history-default" class="ml-2 text-base">I have minor default.</label>
	  </div>

	  <div class="mt-2 flex items-center">
	  	<input type="radio" name="input-credit-history" v-model="creditHistory" value="4" id="input-credit-history-bad" />
	  	<label for="input-credit-history-bad" class="ml-2 text-base">I may have some issues.</label>
	  </div>

	  <template v-if="creditHistory == 4">
  		<div class="text-2xl font-light text-gray-800 mt-12">
        Tell us more about your credit history.
      </div>

      <div class="mt-2">
        <textarea class="input-standard h-48" v-model="lead.creditHistoryInfo"></textarea>
      </div>
    </template>

    <div class="mt-12">
      <a href="#" @click.prevent="next"
        :class="{ 
          'text-white py-4 rounded text-sm uppercase font-semibold inline-block px-16 overflow-hidden' : true, 
          'bg-blue-500 hover:bg-blue-600' : canGoNext(), 
          'bg-gray-500 hover:bg-gray-600' : !canGoNext() }">
        <div class="float-left">Submit</div>

        <svg width="22" height="22" stroke-width="2" class="ml-4 float-left" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
        </svg>
      </a>
    </div>

    <div class="mt-4 ml-2">
      <a href="#" @click.prevent="back()"
        class="text-gray-500 hover:underline">Go back</a>
    </div>
	</div>
</template>

<script>
  export default {

    data() {
      return {
        lead         : null,
        creditHistory: 1
      }
    },

    created() {
      if(this.$route.params.data != null) {
        this.lead = JSON.parse(decodeURIComponent(this.$route.params.data))
      } else {
        this.lead = {}
      }

      if(this.lead.creditHistory != null) {
        this.creditHistory = this.lead.creditHistory
      }
    },

  	methods : {

  		canGoNext() {
        return this.creditHistory != null
      },

      back() {
        this.$router.push({
          name  : 'client-lead-capture-loan-amount',
          params: {
            data : this.$route.params.data != null ? this.$route.params.data : null
          }
        })
      },

      next() {
        let valid = true

        if(valid) {
          this.lead.creditHistory = this.creditHistory

          this.apiPost({
						brokerId: this.$route.params.brokerId,
						lead    : this.lead
          }, 'lead-capture/lead', (data) => {

            // request to process the data and redirect the user
            this.apiPost({
              leadCaptureId : data.id
            }, 'lead-capture/process', () => {

            })

	          this.$router.push({
							name: 'client-lead-capture-submitted'
	          })
	        })
        }
      }
  	}
  }
</script>